import { Team__Coyotes } from "../teams/Coyotes";
import { Team__Nogaleros } from "../teams/Nogaleros";
import { Team__FoxImpresos } from "../teams/FoxImpresos";
import { Team__Cerveceros } from "../teams/Cerveceros";

const Coyotes = {
  team: Team__Coyotes,
  playingPlayers: [],

  goals: 61,
  penaltyGoals: 0,
  isWinner: false,
};

const Nogaleros = {
  team: Team__Nogaleros,
  playingPlayers: [],

  goals: 54,
  penaltyGoals: 0,
  isWinner: false,
};

const FoxImpresos = {
  team: Team__FoxImpresos,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Cerveceros = {
  team: Team__Cerveceros,
  playingPlayers: [],

  goals: 20,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada5 = {
  jornadaPosition: 5,
  matches: [
    {
      team1: Coyotes,
      team2: Nogaleros,

      isCompleted: true,
      isPlaying: false,
      day: "Viernes",
      date: "2026-07-31",
      time: "15:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: FoxImpresos,
      team2: Cerveceros,

      isCompleted: true,
      isPlaying: false,
      day: "Viernes",
      date: "2026-07-31",
      time: "16:00:00",
      location: "Centro Recreativo Lebaron",
    }
  ],
};
